var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWalmart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "walmart",
    xmlns: "http://www.w3.org/2000/svg",
    width: 377.044,
    height: 90.406,
    viewBox: "0 0 377.044 90.406",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_89947",
    "data-name": "Path 89947",
    d: "M148.534,36.2c0-8.928-3.822-16.816-16.747-16.816a30.5,30.5,0,0,0-14.755,3.544l2.093,7.163a21.77,21.77,0,0,1,10.786-3.008c6.544-.009,7.616,3.692,7.616,6.072v.573c-14.284-.023-23.314,4.912-23.314,14.963,0,6.142,4.584,11.9,12.6,11.9A14.422,14.422,0,0,0,138.3,55.505h.24s1.627,6.807,10.624,4.205a59.285,59.285,0,0,1-.628-9.506ZM137.878,45.63a6.879,6.879,0,0,1-.273,2.112,7.459,7.459,0,0,1-7.191,5.051c-2.98,0-5.319-1.687-5.319-5.222,0-5.407,5.97-6.895,12.782-6.858",
    transform: "translate(70.152 11.907)",
    fill: "#0071ce"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_89948",
    "data-name": "Path 89948",
    d: "M0,11.861S9.33,50.031,10.813,56.215c1.747,7.227,4.875,9.9,13.905,8.119l5.832-23.67c1.474-5.864,2.477-10.069,3.429-16.045h.162A157.474,157.474,0,0,0,36.96,40.683s2.38,10.753,3.614,16.387c1.2,5.633,4.584,9.187,13.443,7.264L67.9,11.861H56.692l-4.764,22.7c-1.262,6.576-2.408,11.756-3.3,17.782h-.162c-.8-5.961-1.825-10.929-3.138-17.371l-4.935-23.11H28.7L23.434,34.38c-1.5,6.876-2.907,12.389-3.789,18.226h-.152c-.91-5.476-2.144-12.449-3.452-19.067,0,0-3.129-16.123-4.233-21.678",
    transform: "translate(0 7.285)",
    fill: "#0071ce"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_89949",
    "data-name": "Path 89949",
    d: "M74.472,36.2c0-8.928-3.831-16.816-16.756-16.816A30.519,30.519,0,0,0,42.97,22.931l2.093,7.163a21.7,21.7,0,0,1,10.786-3.008c6.543-.009,7.616,3.692,7.616,6.072v.573c-14.284-.023-23.323,4.912-23.323,14.963,0,6.142,4.6,11.9,12.579,11.9a14.376,14.376,0,0,0,11.5-5.088h.249S66.1,62.312,75.091,59.71a58.845,58.845,0,0,1-.619-9.506v-14ZM63.807,45.63a7.175,7.175,0,0,1-.263,2.112,7.484,7.484,0,0,1-7.209,5.051c-2.962,0-5.31-1.687-5.31-5.222,0-5.407,5.97-6.895,12.782-6.858",
    transform: "translate(24.656 11.907)",
    fill: "#0071ce"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_89950",
    "data-name": "Path 89950",
    d: "M65.012,11.861V64.315H75.677V11.861Z",
    transform: "translate(39.932 7.285)",
    fill: "#0071ce"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_89951",
    "data-name": "Path 89951",
    d: "M155.753,11.861v38.7c0,5.342,1,9.067,3.161,11.35a11.883,11.883,0,0,0,8.688,3.3,25.836,25.836,0,0,0,7.736-1.141l-.129-8.332a17.087,17.087,0,0,1-4.067.471c-3.641,0-4.843-2.306-4.843-7.1V34.3h9.289V24.273H166.3V11.861",
    transform: "translate(95.668 7.285)",
    fill: "#0071ce"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_89952",
    "data-name": "Path 89952",
    d: "M138.675,20.284V59.7H149.7V39.513a14.888,14.888,0,0,1,.24-2.893c.822-4.256,4.053-6.95,8.706-6.95a18.448,18.448,0,0,1,3.161.3V19.633a11.675,11.675,0,0,0-2.394-.226c-4.127,0-8.8,2.62-10.777,8.327h-.272V20.284",
    transform: "translate(85.178 11.92)",
    fill: "#0071ce"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_89953",
    "data-name": "Path 89953",
    d: "M75.456,20.284V59.7H86.2V36.564a8.988,8.988,0,0,1,.5-3.2c.874-2.343,3.041-5.056,6.52-5.056,4.325,0,6.368,3.651,6.368,8.919V59.7h10.717V36.287a11.023,11.023,0,0,1,.443-3.179,6.722,6.722,0,0,1,6.451-4.8c4.372,0,6.488,3.572,6.488,9.783V59.7H134.4V36.458c0-12.209-6.211-17.052-13.263-17.052a14.258,14.258,0,0,0-7.787,2.13,16.881,16.881,0,0,0-5,4.894h-.162a11.244,11.244,0,0,0-10.883-7.024c-6.673,0-9.7,3.369-11.488,6.215h-.162V20.284",
    transform: "translate(46.347 11.92)",
    fill: "#0071ce"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_89954",
    "data-name": "Path 89954",
    d: "M206.147,30.435c2.107,0,3.882-1.1,4.113-2.514l2.089-23.66c0-2.343-2.76-4.261-6.2-4.261-3.461,0-6.2,1.918-6.2,4.261l2.107,23.66c.222,1.414,1.986,2.514,4.095,2.514",
    transform: "translate(122.812)",
    fill: "#fcb61a"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_89955",
    "data-name": "Path 89955",
    d: "M206.335,30.621c1.044-1.848.984-3.9-.143-4.815l-19.5-13.637c-2.029-1.183-5.065.226-6.8,3.212s-1.382,6.326.605,7.486l21.59,10.009c1.382.518,3.189-.444,4.252-2.274",
    transform: "translate(109.807 7.218)",
    fill: "#fcb61a"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_89956",
    "data-name": "Path 89956",
    d: "M212,30.6c1.1,1.83,2.911,2.791,4.256,2.3l21.59-10.037c2.006-1.183,2.306-4.5.61-7.477-1.733-2.985-4.788-4.385-6.812-3.226L212.136,25.784c-1.081.929-1.16,2.99-.116,4.834",
    transform: "translate(129.773 7.22)",
    fill: "#fcb61a"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_89957",
    "data-name": "Path 89957",
    d: "M206.147,37.163c2.107,0,3.882,1.1,4.113,2.514l2.089,23.66c0,2.343-2.759,4.242-6.2,4.242-3.461,0-6.2-1.9-6.2-4.242l2.107-23.66c.222-1.414,1.986-2.514,4.095-2.514",
    transform: "translate(122.812 22.827)",
    fill: "#fcb61a"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_89958",
    "data-name": "Path 89958",
    d: "M212,33.513c1.1-1.835,2.911-2.814,4.256-2.283l21.59,10.019c2.006,1.16,2.306,4.5.61,7.486-1.733,2.962-4.788,4.372-6.812,3.212L212.136,38.3c-1.081-.92-1.16-2.971-.116-4.792",
    transform: "translate(129.773 19.094)",
    fill: "#fcb61a"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_89959",
    "data-name": "Path 89959",
    d: "M206.335,33.493c1.044,1.844.984,3.891-.143,4.815l-19.5,13.619c-2.029,1.183-5.065-.231-6.8-3.193-1.733-2.981-1.382-6.326.605-7.486l21.59-10.019c1.382-.527,3.189.444,4.252,2.264",
    transform: "translate(109.807 19.094)",
    fill: "#fcb61a"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_89960",
    "data-name": "Path 89960",
    d: "M232.528,43.852h.268c.365,0,.513.116.555.407a2.005,2.005,0,0,0,.2.633h.693a1.26,1.26,0,0,1-.18-.652.738.738,0,0,0-.513-.619v-.065a.631.631,0,0,0,.555-.605.8.8,0,0,0-.24-.573,1.881,1.881,0,0,0-.943-.2,4.371,4.371,0,0,0-1.007.1v2.616h.615Zm.018-1.192.314-.042c.37,0,.568.171.568.411,0,.268-.268.393-.61.393h-.273Zm.392-1.775a2.653,2.653,0,1,0,2.7,2.634,2.641,2.641,0,0,0-2.7-2.634m0,.532a2.114,2.114,0,0,1,0,4.224,2.113,2.113,0,0,1-.019-4.224",
    transform: "translate(141.408 25.113)",
    fill: "#fcb61a"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalmart);
export default __webpack_public_path__ + "static/media/walmart.e7a8f18f64c11c189ce33f36371a1c15.svg";
export { ForwardRef as ReactComponent };